import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

import { getDirection, getTranslate, lang } from '../../localization'
import useStyles from './index.styles'

export interface ChangeModalProps {
  title?: string
  isOpen: boolean
  onClose: () => void
  onClick: () => void
  changesFrom?: string
  changesTo?: string
  subtitle?: string
  confirmLabel?: string
  loading?: boolean
  disabled?: boolean
}

export const ChangeModal: React.FC<ChangeModalProps> = ({
  title,
  isOpen,
  onClose,
  onClick,
  changesFrom,
  changesTo,
  subtitle = 'Are you sure you want to change?',
  confirmLabel = 'Change',
  loading = false,
  disabled = false
}) => {
  const classes = useStyles()

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <div className={classes.header}>
            <WarningRoundedIcon className={classes.icon} />
            <Typography variant="h4" className={classes.title}>
              {title ? (
                getTranslate(title)
              ) : lang === 'en' ? (
                <>
                  The Payment Method Is Being Changed From <b>{changesFrom}</b>{' '}
                  To <b>{changesTo}</b>.
                </>
              ) : (
                <>
                  روش پرداخت از <b>{getTranslate(changesFrom || '')}</b> به{' '}
                  <b>{getTranslate(changesTo || '')}</b> در حال تغییر است.
                </>
              )}
            </Typography>

            <Typography variant="h5" className={classes.subTitle}>
              {getTranslate(subtitle)}
            </Typography>
          </div>
          <div className={classes.buttonsContainer}>
            <Button variant="text" color="primary" onClick={onClose}>
              <Typography variant="h5" className={classes.cancelText}>
                {getTranslate('Cancel')}
              </Typography>
            </Button>
            <Button
              variant="contained"
              className={classes.deleteButton}
              onClick={onClick}
              disabled={disabled || loading}
              color="primary">
              <Typography variant="h5" className={classes.changeText}>
                {getTranslate(loading ? 'Please wait' : confirmLabel)}
              </Typography>
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
